module.exports = __webpack_public_path__ + "f992c41059189ac776eefa8083f1645c.pdf";